
/* eslint-disable import/no-named-default */
// import customAdminRoutes from './chinlai/routes/admin'
// import customRetailRoutes from './chinlai/routes/retail'
// import customWorkstationRoutes from './chinlai/routes/workstation'
import customAdminRoutes from './sdgrouphub/routes/admin'

import customAdminSiderbar from './sdgrouphub/layouts/admin/SidebarConfig'
// import customAdminSiderbar from './chinlai/layouts/admin/SidebarConfig'
// import customRetailSiderbar from './chinlai/layouts/retail/SidebarConfig'
// import customWorkstationSiderbar from './chinlai/layouts/workstation/SidebarConfig'

// import _customSystemLogo from './nytgroup/components/common/SystemLogo'
// import _customSystemLogo from './chinlai/components/common/SystemLogo'
// import _customSystemLogo from './lovy/components/common/SystemLogo'
// import _customSystemLogo from './koi/components/common/SystemLogo'
import _customSystemLogo from './sdgrouphub/components/common/SystemLogo'

export const customRoutes = {
    admin: customAdminRoutes,
    // retail: customRetailRoutes,
    // workstation: customWorkstationRoutes,
}

export const customSiderbars = {
    admin: customAdminSiderbar,
    // retail: customRetailSiderbar,
    // workstation: customWorkstationSiderbar,
}

export const customLayoutFrames = {
    // admin: customAdminLayoutFrame,
    // public: customPublicLayoutFrame,
    // retail: customRetailLayoutFrame,
    // workstation: '',
    // customer: ''
}

export const customSystemLogoConfigs = {
    enabled: true,
    component: _customSystemLogo
}